import 'primeflex/primeflex.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

import '@fortawesome/fontawesome-free/css/all.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/nova-light/theme.css';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import 'react-flow-renderer/dist/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-image-crop/dist/ReactCrop.css';
import 'react-awesome-lightbox/build/style.css';
import './statics/styles/index.scss';

import { patchPrimeReactViFilter } from './utilities/primereactViFilter';
import { theoDoiCanDoiBang } from './utilities/canDoiBang';

// Bật tìm kiếm không dấu tiếng Việt cho mọi bộ lọc của PrimeReact (MultiSelect,
// Dropdown, AutoComplete, DataTable filter...). Phải chạy TRƯỚC khi render.
patchPrimeReactViFilter();

// Bảng tự co trong HỘP NỔI của Phân việc khách hàng / tài xế (Lịch sử khách, Lịch sử
// tài xế, bảng nhỏ trong hộp) tự CÂN CỘT: cột ít chữ đủ một dòng, cột nhiều chữ chia
// phần còn lại và xuống dòng (QA 25/10/2026, xem utilities/canDoiBang.ts).
theoDoiCanDoiBang(document.body, '.pv-hop-than table');

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
